import CreateInvestmentError from './CreateInvestmentError';
class InvestorDoesNotOwnCoupon extends CreateInvestmentError {
    constructor(options) {
        super('Investor does not own the coupon', options);
    }
}
export default InvestorDoesNotOwnCoupon;
